import type {
  ProfileSettingInvalidParam,
  ProfileSettingInvalidParams,
} from './useProfileSettingForm';

export type InvalidErrors = {
  profileImageError?: ProfileSettingInvalidParam;
  profileImageExtensionError?: ProfileSettingInvalidParam;
  selfIntroductionError?: ProfileSettingInvalidParam;
  preferredUsernameError?: ProfileSettingInvalidParam;
  givenNameError?: ProfileSettingInvalidParam;
  familyNameError?: ProfileSettingInvalidParam;
  givenNameKanaError?: ProfileSettingInvalidParam;
  familyNameKanaError?: ProfileSettingInvalidParam;
  genderError?: ProfileSettingInvalidParam;
  birthdateError?: ProfileSettingInvalidParam;
  emailError?: ProfileSettingInvalidParam;
  phoneNumberError?: ProfileSettingInvalidParam;
  postalCodeError?: ProfileSettingInvalidParam;
  prefectureIdError?: ProfileSettingInvalidParam;
  localityError?: ProfileSettingInvalidParam;
  streetAddressError?: ProfileSettingInvalidParam;
  buildingError?: ProfileSettingInvalidParam;
  marriageStatusError?: ProfileSettingInvalidParam;
  hasChildrenError?: ProfileSettingInvalidParam;
  qualificationCodeListError?: ProfileSettingInvalidParam;
  employmentIdError?: ProfileSettingInvalidParam;
  affiliationIdsError?: ProfileSettingInvalidParam;
  activityAreaIdsError?: ProfileSettingInvalidParam;
  licenseIdsError?: ProfileSettingInvalidParam;
  customLicenseError?: ProfileSettingInvalidParam;
  nurseLicenseNumberError?: ProfileSettingInvalidParam;
  schoolNameError?: ProfileSettingInvalidParam;
  graduationYearError?: ProfileSettingInvalidParam;
  schoolTypeIdError?: ProfileSettingInvalidParam;
  scholarshipStatusError?: ProfileSettingInvalidParam;
  scholarshipTypeError?: ProfileSettingInvalidParam;
  borrowingPeriodError?: ProfileSettingInvalidParam;
};

// eslint-disable-next-line max-lines-per-function
export const createInvalidErrors = (
  invalidParams?: ProfileSettingInvalidParams,
): InvalidErrors => ({
  profileImageError: invalidParams?.find(
    (value) => value.name === 'profileImage',
  ),
  profileImageExtensionError: invalidParams?.find(
    (value) => value.name === 'profileImageExtension',
  ),
  selfIntroductionError: invalidParams?.find(
    (value) => value.name === 'selfIntroduction',
  ),
  preferredUsernameError: invalidParams?.find(
    (value) => value.name === 'preferredUsername',
  ),
  givenNameError: invalidParams?.find((value) => value.name === 'givenName'),
  familyNameError: invalidParams?.find((value) => value.name === 'familyName'),
  givenNameKanaError: invalidParams?.find(
    (value) => value.name === 'givenNameKana',
  ),
  familyNameKanaError: invalidParams?.find(
    (value) => value.name === 'familyNameKana',
  ),
  genderError: invalidParams?.find((value) => value.name === 'gender'),
  birthdateError: invalidParams?.find((value) => value.name === 'birthdate'),
  emailError: invalidParams?.find((value) => value.name === 'email'),
  phoneNumberError: invalidParams?.find(
    (value) => value.name === 'phoneNumber',
  ),
  postalCodeError: invalidParams?.find((value) => value.name === 'postalCode'),
  prefectureIdError: invalidParams?.find(
    (value) => value.name === 'prefectureId',
  ),
  localityError: invalidParams?.find((value) => value.name === 'locality'),
  streetAddressError: invalidParams?.find(
    (value) => value.name === 'streetAddress',
  ),
  buildingError: invalidParams?.find((value) => value.name === 'building'),
  marriageStatusError: invalidParams?.find(
    (value) => value.name === 'marriageStatus',
  ),
  hasChildrenError: invalidParams?.find(
    (value) => value.name === 'hasChildren',
  ),

  qualificationCodeListError: invalidParams?.find(
    (value) => value.name === 'qualificationCodeList',
  ),
  employmentIdError: invalidParams?.find(
    (value) => value.name === 'employmentId',
  ),
  affiliationIdsError: invalidParams?.find(
    (value) => value.name === 'affiliationIds',
  ),
  activityAreaIdsError: invalidParams?.find(
    (value) => value.name === 'activityAreaIds',
  ),
  licenseIdsError: invalidParams?.find((value) => value.name === 'licenseIds'),
  customLicenseError: invalidParams?.find(
    (value) => value.name === 'customLicense',
  ),
  nurseLicenseNumberError: invalidParams?.find(
    (value) => value.name === 'nurseLicenseNumber',
  ),
  schoolNameError: invalidParams?.find((value) => value.name === 'schoolName'),
  graduationYearError: invalidParams?.find(
    (value) => value.name === 'graduationYear',
  ),
  schoolTypeIdError: invalidParams?.find(
    (value) => value.name === 'schoolTypeId',
  ),
  scholarshipStatusError: invalidParams?.find(
    (value) => value.name === 'scholarshipStatus',
  ),
  scholarshipTypeError: invalidParams?.find(
    (value) => value.name === 'scholarshipType',
  ),
  borrowingPeriodError: invalidParams?.find(
    (value) => value.name === 'borrowingPeriod',
  ),
});
